import { Suspense } from 'react';
import { InlineStack } from '@customerio/pluma-components/react';
import type { DeliveryFilterValues, DeliverySearchBy } from '../types';
import { CampaignActionFilters } from './campaign-action-filters';
import { RecipientSearch } from './recipient-search';

type FilterRowProps = {
  searchBy: DeliverySearchBy;
  isEmailChannel: boolean;
  values: DeliveryFilterValues;
  drafted: boolean;
  fixed: ReadonlySet<string>;
  isDisabled: boolean;
  onCampaignChange: (value: string | null) => void;
  onActionChange: (value: string | null) => void;
  onRecipientChange: (term: string) => void;
};

/**
 * The contextual filter row: the email-address search (email search mode) or
 * the campaign + action selects (filter search mode). The campaign/action
 * selects fetch the workspace's filter options, so they render under a Suspense
 * boundary to avoid blocking the rest of the bar.
 */
export function FilterRow({
  searchBy,
  isEmailChannel,
  values,
  drafted,
  fixed,
  isDisabled,
  onCampaignChange,
  onActionChange,
  onRecipientChange,
}: FilterRowProps) {
  return (
    <InlineStack alignBlock="flex-end" gap="100">
      {searchBy === 'email' && isEmailChannel ? (
        <RecipientSearch recipient={values.recipient} onChange={onRecipientChange} isDisabled={isDisabled} />
      ) : (
        <Suspense fallback={null}>
          <CampaignActionFilters
            channel={values.actionType}
            drafted={drafted}
            campaign={values.campaign}
            action={values.action}
            onCampaignChange={onCampaignChange}
            onActionChange={onActionChange}
            fixed={fixed}
            isDisabled={isDisabled}
          />
        </Suspense>
      )}
    </InlineStack>
  );
}
